module.exports = __webpack_public_path__ + "static/media/yotes-court-vineyard-logo.a4056734.avif";